<template>
	<div id="home">
		<HeaderPC :search="search"></HeaderPC>
		<div class="width1200 content">
			<!-- <ul :class="'left-nav '+(navFixed?'fixed':'')">
				<li v-for="(item,index) in navList" :class="navSelect==index?'active':''" @click="navChange(index)">{{item.name}}</li>
			</ul> -->
			<ul :class="'left-nav '+(navFixed?'fixed':'')">
				<li v-for="(item,index) in lists" :class="navSelect==index?'active':''" @click="navChange(index)"><img :src="item.icon_url||icon" alt="">{{item.title}}</li>
			</ul>
			<div class="right-box">
				<div v-if="lists.length==0">暂无数据</div>
				<div class="box" :id="'box'+item.id" v-for="(item,index) in lists">
					<h2><img :src="item.icon_url||icon" alt="">{{item.title}}</h2>
					<p class="description">{{item.description}}</p>
					<div class="list">
						<div class="list-box" v-for="(item2,index2) in item.lists" :style="'background: '+(item2.bg_color)+';'">
							<div class="left">
								<div class="top">
									<div class="logo"><img :src="item2.icon_url" alt=""></div>
									<div class="con">
										<p class="title">{{item2.title}}</p>
										<p class="desciption">{{item2.description}}</p>
									</div>
								</div>
								<div class="bottom">
									<a :href="item2.type==1?item2.pc_url:'/pdfjs/web/viewer.html?file='+item2.file_url" class="btn">立即访问</a>
									<p class="url">手机扫码访问>></p>
								</div>
							</div>
							<div class="qrcode"><img :src="item2.qrcode" alt=""></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<FooterPC></FooterPC>
	</div>
</template>

<script>
export default {
  mounted() {
	  window.addEventListener("scroll", this.scrolling);
	  // this.search=this.$route.query.search
	  this.getlist();
  },
  data() {
    return {
      navSelect: 0,
	  navList:[
		{name:"常用推荐"},
		{name:"综合资料"},
		{name:"耗材资料"},
		{name:"产品选型"},
		{name:"技术方案"},
		{name:"服务方案"},
		{name:"售后服务"},
	  ],
	  navFixed:false,
	  lists:[],
	  listsScrollTop:[],
	  search:this.$route.query.search,
	  icon: require("@/assets/images/icon.png")
    }
  },
  components: {
	  
  },
  watch:{
	  lists:function(){
		  this.$nextTick(function(){  
			var listsScrollTop=[];
			this.lists.forEach(function(item,index){
				listsScrollTop.push(document.getElementById("box"+item.id).offsetTop)
			})
			this.listsScrollTop=listsScrollTop
		  })
	  }
  },
  methods: {
	  getlist(txt){
		  this.fetchGet(`/api/v1/ent`,{search:txt?txt:this.search}).then((res) => {
			if(res.code==200){
				this.lists=res.data.data
			}
		  })
	  },
	  navChange(item){
		  document.documentElement.scrollTop=this.listsScrollTop[item]
	  },
	  scrolling(){
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
		let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
		let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
		if(scrollTop>129){
			this.navFixed=true
		}else{
			this.navFixed=false
		}
		let target = this.listsScrollTop;
		const output = target.find(item => item > scrollTop);
		var navSelect=target.indexOf(output)-1;
		if(navSelect<0){
			navSelect=0
		}
		this.navSelect=navSelect
	  }
  },
}
</script>
<style scoped>
	.content{margin-top: 25px;overflow: hidden;}
	#home .left-nav{width: 295px;border: 1px solid #000000;float: left;background: #f8f8f8;}
	#home .left-nav.fixed{position: fixed;top: 25px;}
	#home .left-nav li{text-align: center;line-height: 94px;border-bottom: 1px solid #000;font-size: 28px;cursor: pointer;}
	#home .left-nav li img{width: 29px;height: 29px;vertical-align: top;margin-top: 32.5px;margin-right: 17px;}
	#home .left-nav li:nth-last-of-type(1){border: none;}
	#home .left-nav li.active{font-weight: bold;color: #0096D6;}
	#home .right-box{width: 795px;float: right;}
	#home .right-box .box{margin-bottom: 18px;}
	#home .right-box .box h2{font-size: 28px;line-height: 54px;border-bottom: 1px solid #000;font-weight: 400;}
	#home .right-box .box h2 img{width: 29px;height: 29px;vertical-align: top;margin-top: 12.5px;margin-right: 13px;}
	#home .right-box .box .description{font-size: 20px;line-height: 44px;}
	#home .right-box .box .list{margin-top: 10px;overflow: hidden;}
	#home .right-box .box .list .list-box{float: left;margin: 0 10px 12px 0;/* border: 2px solid #09BBFE; */width: 392px;box-sizing: border-box;padding: 11px 12px 10px 18px;display: flex;background: linear-gradient(90deg, rgba(0,150,214,0.96), rgba(130,68,199,0.96));}
	#home .right-box .box .list .list-box:nth-of-type(2n){margin-right: 0;}
	#home .right-box .box .list .list-box .left{width: 100%;}
	#home .right-box .box .list .list-box .left .top{display: flex;}
	#home .right-box .box .list .list-box .logo{width: 39px;height: 41px;margin-right: 13px;flex: 0 0 auto;background: #fff;border-radius: 4px;}
	#home .right-box .box .list .list-box .logo img{width: 31px;height: 31px;margin: 5px auto;display: block;}
	#home .right-box .box .list .list-box .con{width: 100%;}
	#home .right-box .box .list .list-box .con .title{font-size: 20px;line-height: 20px;color: #000;}
	#home .right-box .box .list .list-box .con .desciption{font-size: 12px;line-height: 14px;color: #6D6D6D;margin-top: 8px;color: #000;height: 28px;}
	#home .right-box .box .list .list-box .qrcode{width: 90px;height: 90px;margin-left: 17px;flex: 0 0 auto;background: #fff;}
	#home .right-box .box .list .list-box .qrcode img{width: 80px;height: 80px;margin: 5px auto;display: block;}
	#home .right-box .box .list .list-box .bottom{overflow: hidden;margin-top: 8px;}
	#home .right-box .box .list .list-box .bottom .btn{width: 91px;height: 27px;line-height: 27px;background: #ffffff;color: #35332E;font-size: 14px;display: inline-block;text-align: center;float: left;}
	#home .right-box .box .list .list-box .bottom .url{font-size: 12px;line-height: 27px;color: #6D6D6D;color: #000;float: right;}
</style>